module.exports = __webpack_public_path__ + "static/media/hours.7b91b023.png";